import { render, staticRenderFns } from "./Me.vue?vue&type=template&id=485d1f4a&scoped=true&"
import script from "./Me.vue?vue&type=script&lang=js&"
export * from "./Me.vue?vue&type=script&lang=js&"
import style0 from "./Me.vue?vue&type=style&index=0&id=485d1f4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d1f4a",
  null
  
)

export default component.exports